import { createMuiTheme } from 'material-ui/styles';
import createPalette from 'material-ui/styles/palette';
import indigo from 'material-ui/colors/indigo';
import amber from 'material-ui/colors/amber';

const GRADIENT_PRIMARY = 'linear-gradient(to right, #4776e6, #8e54e9)'; // Electric Violet
const GRADIENT_ACCENT = 'linear-gradient(to right, #f7971e, #ffd200)';

const theme = createMuiTheme({
  palette: createPalette({
    primary: indigo,
    accent: amber,
  }),
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        background: GRADIENT_PRIMARY,
      },
    },
    MuiButton: {
      raisedPrimary: {
        background: GRADIENT_PRIMARY,
      },
      raisedAccent: {
        background: GRADIENT_ACCENT,
      },
    },
    MuiCard: {
      root: {
        marginBottom: 8,
      },
    },
  },
});

export default theme;



// WEBPACK FOOTER //
// ./src/App/theme.js